<div class="col-12 pet-title-wrap">
  <h4 class="pet-section-title">{{ "yourpettype" | transloco }}</h4>
</div>

<div class="scroll-menu pet-menu">

  <div class="scroll-item pet-type-card" (click)="byPet('cats',0)">
    <div class="pet-type-visual">
      <div class="pet-type-circle"></div>
      <div class="pet-type-img-wrap">
        <img src="/assets/e-commerce/icons/8.webp" alt="cats">
      </div>
    </div>
    <p class="pet-type-name">{{ "cats" | transloco }}</p>
  </div>

  <div class="scroll-item pet-type-card" (click)="byPet('dogs',1)">
    <div class="pet-type-visual">
      <div class="pet-type-circle"></div>
      <div class="pet-type-img-wrap">
        <img src="/assets/e-commerce/icons/11.webp" alt="dogs">
      </div>
    </div>
    <p class="pet-type-name">{{ "dogs" | transloco }}</p>
  </div>

  <div class="scroll-item pet-type-card" (click)="byPet('catsanddogs',4)">
    <div class="pet-type-visual">
      <div class="pet-type-circle"></div>
      <div class="pet-type-img-wrap">
        <img src="/assets/e-commerce/icons/10.webp" alt="cats&dogs">
      </div>
    </div>
    <p class="pet-type-name">{{ "cats&dogs" | transloco }}</p>
  </div>

  <div class="scroll-item pet-type-card" (click)="byPet('birds',2)">
    <div class="pet-type-visual">
      <div class="pet-type-circle"></div>
      <div class="pet-type-img-wrap">
        <img src="/assets/e-commerce/icons/13.webp" alt="birds">
      </div>
    </div>
    <p class="pet-type-name">{{ "birds" | transloco }}</p>
  </div>

  <div class="scroll-item pet-type-card" (click)="byPet('other',3)">
    <div class="pet-type-visual">
      <div class="pet-type-circle"></div>
      <div class="pet-type-img-wrap">
        <img src="/assets/e-commerce/icons/25.png" alt="other">
      </div>
    </div>
    <p class="pet-type-name">{{ "other" | transloco }}</p>
  </div>

</div>